import React, { Component } from "react";
import { Button, ButtonGroup, Container } from "reactstrap";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Col, Row } from "reactstrap";
//import axios from 'axios';
import {
  getGPT3ParseExtractInfo,
  getGPT3CustomPromptCompletion,
  getGPT3DiarizationPromptCompletion,
  getGPT3Summarize,
  getKeyPhrases,
  getTokenOrRefresh,
} from "./token_util.js";
import { ResultReason } from "microsoft-cognitiveservices-speech-sdk";
import "./App.css";
//import { Input } from '@material-ui/core';
import { parse } from "iso8601-duration";
import App from "./App.js";
import { getPrompts } from "./prompt_util.js";
import Logo from "./images/TJX-Logo.png";
import ctlogo from "./images/CTS-logo.png";

const speechsdk = require("microsoft-cognitiveservices-speech-sdk");
var recognizer;

// const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT !== undefined ? process.env.REACT_APP_BACK_END_ENDPOINT : 'https://wapi-#{CLIENTNAME}##{INSTANCE}#-sdinsight.azurewebsites.net';
const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT ?? '';

console.log("Configured backend endpoint is :" + backend_endpoint);

// const BatchPage  = () => {
export default class BatchPage extends Component {
  constructor(props) {
    super(props);

    this.state = { value: "", language: 'en-US' };
    this.audioRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileInputChange = this.handleFileInputChange.bind(this);
    this.handleTranscribeButtonClick = this.handleTranscribeButtonClick.bind(
      this
    );
    this.handleSentenceClick = this.handleSentenceClick.bind(this);
    this.handleWindowClick = this.handleWindowClick.bind(this);
    this.toggle = this.toggle.bind(this);

    this.state = {
      displayText: "READY to start call simulation",
      displayNLPOutput: "",
      gptSummaryText: "",
      gptExtractedInfo: "",
      gptCustomPrompt: "",
      gptCustomPrompt2: "",
      gptPrompt: "",
      gptPrompt2: "",
      timeText: "",
      activeWindow: "window2",
      modifiedConversation1: [],
      timestamps: [],
      currentTime: 0,
      objectURL: "",
      selectedPrompt: "",
    };
  }

  state = {
    // Initially, no file is selected
    selectedFile: null,
    selectedFileName: null,
    formSelectBatchLanguage: "en-IN",
    masterTextareaRef: null,
    slaveTextareaRef: null,
    numberingElements: null,
    sentenceElements: null,
    hoveredButton: "",
    isLoading: false,
    isPlaying: false,
    currentSentenceIndex: -1,
    showBatchPage: true,
  };

  handleFileInputChange = (event) => {
    this.setState({ selectedFile: event.target.files[0] });
    // this.setState({selectedFileName: event.target.files[0].name});
  };

  handleTranscribeButtonClick = async () => {
    if (this.state.selectedFile == null) {
      alert("Choose a file before clicking TRANSCRIBE BUTTON!");
    }

    const formData = new FormData();
    formData.append("audio", this.state.selectedFile);
    formData.append(
      "language",
      document.getElementById("formSelectBatchLanguage").value
    ); // Get the selected value of the select element
    console.log(formData);

    try {
      this.setState({ isLoading: true });

      const endpoint = backend_endpoint 
          ? `${backend_endpoint}/api/upload` 
          : '/api/upload'

      fetch(endpoint, {
          method: "POST",
          mode: "cors",
          body: formData,
        })
        // console.log(response.data);
        .then((response) => response.json()) // Parse the response as JSON
        .then((data) => {
          console.log(data);
          this.setState({ isLoading: false });
          const ttext = document.getElementById("transcriptTextarea");

          ttext.value = "";
          var res = "";
          var result = [];
          var timestamp = [];
          var dic = {};

          for (let i = 0; i < data["recognizedPhrases"].length; i++) {
            if (data["recognizedPhrases"][i]["channel"] === 1) {
              data["recognizedPhrases"][i]["speaker"] = 1;
            }

            //TimeStamps
            dic[i] = data["recognizedPhrases"][i]["offsetInTicks"] / 10000000;
          }

          var element = [];

          //sorted dic values
          const sortedEntries = Object.entries(dic).sort((a, b) => a[1] - b[1]);

          for (let i = 0; i < sortedEntries.length; i++) {
            const innerList = sortedEntries[i];
            element.push(innerList[0]);
          }
          // console.log(element);

          for (let i = 0; i < element.length; i++) {
            var k = null;
            k = element[i];

            // Find the index of the nBest object with the largest confidence value
            // const maxConfidenceIndex = data["recognizedPhrases"][k].nBest.reduce((maxIndex, currentNBest, currentIndex, nBestArray) => {
            //   if (currentNBest.confidence > nBestArray[maxIndex].confidence) {
            //     return currentIndex;
            //   } else {
            //     return maxIndex;
            //   }
            // }, 0);
            // console.log(maxConfidenceIndex);

            //Sentiment Analysis

            if (data.recognizedPhrases[k].nBest[0].sentiment !== undefined){
              const { negative, positive, neutral } = data.recognizedPhrases[k].nBest[0].sentiment;

              let largestElement = "";
              if (negative > positive && negative > neutral) {
                largestElement = "negative";
              } else if (positive > negative && positive > neutral) {
                largestElement = "positive";
              } else {
                largestElement = "neutral";
              }

              timestamp.push(
                data["recognizedPhrases"][k]["offsetInTicks"] / 10000000
              );
              this.setState({ timestamps: timestamp });
              //if(!data["conversationAnalyticsResults"]["conversationPiiResults"]){
              res =
                " Speaker " +
                data["recognizedPhrases"][k]["speaker"] +
                ": " +
                data["recognizedPhrases"][k]["nBest"][0]["display"] +
                " {" +
                largestElement +
                "}";
              result.push(res);
              ttext.value += res + "\n\n";
            }
            
            //}
            //else{
            //  res = ' Speaker ' + data["recognizedPhrases"][k]["speaker"] + ": " + data["conversationAnalyticsResults"]["conversationPiiResults"]["conversations"][0]["conversationItems"][k]["redactedContent"]["text"] + ' {' + largestElement + '}';
            // Comment above, Uncomment below to toggle redaction.
            //res = ' Speaker ' + data["recognizedPhrases"][k]["speaker"] + ": " + data["recognizedPhrases"][k]["nBest"][0]["display"] + ' {' + largestElement + '}';

            //  result.push(res);
            //  ttext.value += res + '\n\n';
            //}
          }

          //Replacing 'Speaker 0 and 1 with Agent or Customer'
          // const getProfileInfos = async () => {
          //   var PersonObj = await this.gptPersonInfo();

          //   ttext.value = '';

          //   const replacements = JSON.parse(PersonObj);

          //   const modifiedConversation = result.map(line => {
          //     return line.replace(/Speaker \d/g, match => replacements[match]);
          //   });

          //   for (let i = 0; i < modifiedConversation.length; i++) {

          //     ttext.value += modifiedConversation[i];

          //   }

          //   this.setState({ modifiedConversation1: modifiedConversation })
          //   console.log(this.state.modifiedConversation1);

          // }

          //sgetProfileInfos();

          //Added insted of above code

          // let replacements = [
          //   { 'Speaker 0': 'Agent', 'Speaker 1': 'Customer' }
          // ];
          // const modifiedConversation = result.map(line => {
          //   return line.replace(/Speaker \d/g, match => replacements[match]);
          // });

          const modifiedConversation = result;

          for (let i = 0; i < modifiedConversation.length; i++) {
            ttext.value += modifiedConversation[i];
          }

          this.setState({ modifiedConversation1: modifiedConversation });
          console.log(this.state.modifiedConversation1);

          //display duration of the audio file

          const timevalue = document.getElementById("durationtextarea");

          var t = [];
          t.push(parse(data["duration"])["hours"]);
          t.push(parse(data["duration"])["minutes"]);
          t.push(parse(data["duration"])["seconds"]);
          timevalue.value =
            t[0] +
            " " +
            "hours" +
            "  " +
            t[1] +
            " " +
            "minutes" +
            "  " +
            t[2] +
            " " +
            "seconds";
          this.setState({ timeText: timevalue });
        });
    } catch (error) {
      console.error(error);
      this.setState({ isLoading: false });
    }
  };

  playAudio = () => {
    const { selectedFile } = this.state;
    const { objectURL, currentTime } = this.state;
    if (selectedFile) {
      if (objectURL !== "") {
        this.audioRef.current.src = objectURL;
        this.audioRef.current.currentTime = currentTime;
        this.audioRef.current.play();
      } else {
        const newObjectURL = URL.createObjectURL(selectedFile);
        this.setState({ objectURL: newObjectURL }, () => {
          this.audioRef.current.src = newObjectURL;
          this.audioRef.current.currentTime = currentTime;
          this.audioRef.current.play();
        });
      }
      this.setState({ isPlaying: true });
    }
  };

  pauseAudio = () => {
    this.audioRef.current.pause();
    this.setState({ isPlaying: false });
  };

  handleTimeUpdate = (event) => {
    const currentTime = event.target.currentTime;
    this.setState({ currentTime: currentTime });

    if (this.state.isPlaying) {
      // Find the index of the sentence based on the current time
      const currentIndex = this.state.timestamps.findIndex(
        (timestamp) => timestamp >= currentTime
      );
      if (currentIndex !== -1) {
        this.setState({ currentSentenceIndex: currentIndex - 1 });
      }
    }
  };

  handleSentenceClick = (index) => {
    var key = index["index"];
    console.log("index of sentence clicked:", key);
    var clickedTimestamp = this.state.timestamps;
    console.log(clickedTimestamp[key]);

    this.setState({ currentTime: clickedTimestamp[key] }, () => {
      this.audioRef.current.currentTime = clickedTimestamp[key];
      if (!this.audioRef.current.paused) {
        this.audioRef.current.play();
      }
    });
  };

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      showBatchPage: !prevState.showBatchPage,
    }));
  };

  handleWindowClick = (windowName) => {
    this.setState({ showBatchPage: windowName });
  };

  handleChange(event) {
    this.setState({ value: event.target.value });
    alert("You have selected conversation category : " + this.state.value);
  }

  handleSubmit(event) {
    alert(
      "Your conversation will be saved with name : " +
        this.state.value +
        " Submit a different name to change it."
    );
    event.preventDefault();
  }

  async componentDidMount() {
    try {
      const promptList = await getPrompts();

      if (promptList.prompts === null) {
        console.error("No prompt list. \n\t" + promptList.error);
      }

      console.log("Successfully retrieved prompt list. " + promptList);

      this.setState({ prompts: promptList.prompts });
    } catch (error) {
      console.error("Error getting prompt list " + error);
    }
    // check for valid speech key/region
    const tokenRes = await getTokenOrRefresh();
    if (tokenRes.authToken === null) {
      this.setState({
        displayText: "FATAL_ERROR amc: " + tokenRes.error,
      });
    }
  }

  async sttFromMic() {
    const tokenObj = await getTokenOrRefresh();
    const speechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(
      tokenObj.authToken,
      tokenObj.region
    );
    //speechConfig.speechRecognitionLanguage = 'en-US';

    var convLanguage = document.getElementById("formSelectConvLanguage").value;

    speechConfig.speechRecognitionLanguage = convLanguage;
    const audioConfig = speechsdk.AudioConfig.fromDefaultMicrophoneInput();
    recognizer = new speechsdk.SpeechRecognizer(speechConfig, audioConfig);

    this.setState({
      displayText:
        "Click Start listening and Speak to your microphone",
    });

    let resultText = "";
    let nlpText = " ";
    recognizer.sessionStarted = (s, e) => {
      //this.setState({displayText: resultText});
    };

    recognizer.recognized = async (s, e) => {
      if (e.result.reason === ResultReason.RecognizedSpeech) {
        //Display continuous transcript
        resultText += `\n${e.result.text}`;
        this.setState({
          displayText: resultText,
        });

        //Display continuous transcript in the text area
        document.getElementById("transcriptTextarea").value = resultText;

        //Perform continuous NLP
        //const nlpObj = await getKeyPhrases(e.result.text);

        //Display extracted Key Phrases
        // const keyPhraseText = JSON.stringify(nlpObj.keyPhrasesExtracted);
        // if (keyPhraseText.length > 15) {
        //   //nlpText += "\n" + keyPhraseText;
        //   //this.setState({ displayNLPOutput: nlpText });
        // }

        //Display extracted entities
        // const entityText = nlpObj.entityExtracted;
        // if (entityText.length > 12) {
        //   nlpText += "\n" + entityText;
        //   this.setState({ displayNLPOutput: nlpText.replace("<br/>", "\n") });
        // }

        //Display PII Detected
        /*const piiText = nlpObj.piiExtracted;
              if(piiText.length > 21){
                  nlpText += "\n" + piiText; 
                  this.setState({ displayNLPOutput: nlpText.replace('<br/>', '\n') }); 
              }      */
      } else if (e.result.reason === ResultReason.NoMatch) {
        //resultText += `\nNo Match`
        resultText += `\n`;
      }
    };
    recognizer.startContinuousRecognitionAsync();
  }

  async gptPersonInfo(inputText) {
    // var customPromptText = "This is a call centre conversation between two people (Speaker 0 and Speaker 1) , one of which is Agent and another is Customer. Can you categorize Speaker 0 and Speaker 1 into either one of agent and customer ?  Store the result in a dictionary { key:value } where key-value pair is the speaker and his/her category respectively. Make sure to use double quotes for keys and string values.";
    var customPromptText =
      "In the given call center conversation, categorize Speaker 0 and Speaker 1 into 'Agent' or 'Customer' after analysing their behavior. Store the result in a dictionary { key:value } where key-value pair is the speaker and his/her category respectively. Make sure to use double quotes for keys and string values";
    var transcriptInputForCA = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3CustomPromptCompletion(inputText, customPromptText);
    const gptObj = await getGPT3DiarizationPromptCompletion(
      transcriptInputForCA,
      customPromptText
    );
    const gptText = gptObj.data.text;
    console.log(gptObj);
    console.log(gptText);
    try {
      this.setState({ gptPrompt: gptText.replace(".\n\n", "") });
      return gptText.replace(".\n\n", "");
    } catch {
      this.setState({ gptPrompt: gptObj.data });
    }
  }

  async gptKeyTopics(inputText) {
    var customPromptText =
      "In the transcribed call log, Speaker 1 is the agent and Speaker 2 is the caller.\nYour goal is to extract key topics discussed through out the call.\nKeep topics short and concise.\nUse numeric bullet points to list key topics.";
    var transcriptInputForCA = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3CustomPromptCompletion(inputText, customPromptText);
    const gptObj = await getGPT3CustomPromptCompletion(
      transcriptInputForCA,
      customPromptText
    );
    const gptText = gptObj.data.text;
    try {
      this.setState({ gptPrompt2: gptText.replace("\n\n", "") });
    } catch {
      this.setState({ gptPrompt2: gptObj.data });
    }
  }

  async gptCustomPromptCompetion(inputText) {
    var customPromptText = document.getElementById("customPromptTextarea")
      .value;
    var transcriptInputForPmt = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3CustomPromptCompletion(inputText, customPromptText);
    const gptObj = await getGPT3CustomPromptCompletion(
      transcriptInputForPmt,
      customPromptText
    );
    const gptText = gptObj.data.text;
    try {
      this.setState({ gptCustomPrompt: gptText.replace("\n\n", "") });
    } catch (error) {
      this.setState({ gptCustomPrompt: gptObj.data });
    }
  }

  async gptCustomPromptCompetion2(inputText) {
    var customPromptText = document.getElementById("customPromptTextarea2")
      .value;
    var transcriptInputForPmt2 = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3CustomPromptCompletion(inputText, customPromptText);
    const gptObj = await getGPT3CustomPromptCompletion(
      transcriptInputForPmt2,
      customPromptText
    );
    const gptText = gptObj.data.text;
    try {
      this.setState({ gptCustomPrompt2: gptText.replace("\n\n", "") });
    } catch (error) {
      this.setState({ gptCustomPrompt2: gptObj.data });
    }
  }

  async gptSummarizeText(inputText) {
    var transcriptInputForSumr = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3Summarize(inputText);
    const gptObj = await getGPT3Summarize(transcriptInputForSumr);
    const gptText = gptObj.data.text;
    //recognizer.stopContinuousRecognitionAsync();
    this.setState({ gptSummaryText: gptText.replace("\n\n", "") });
  }

  async stopRecording() {
    recognizer.stopContinuousRecognitionAsync();
  }

  async gptParseExtractInfo(inputText) {
    var selectConvScenario = document.getElementById("formSelectConvScenario");
    var convScenario =
      selectConvScenario.options[selectConvScenario.selectedIndex].text;
    var transcriptInputToExtract = document.getElementById("transcriptTextarea")
      .value;
    const gptObj = await getGPT3ParseExtractInfo(
      transcriptInputToExtract,
      convScenario
    );
    //const gptObj = await getGPT3ParseExtractInfo(inputText, convScenario);
    const gptText = gptObj.data.text;
    this.setState({ gptExtractedInfo: gptText.replace("\n\n", "") });
  }

  async handleAIPromptDropdownSelect(x) {
    var element = document.getElementById("customPromptTextarea");
    element.value = x.prompt;
    this.setState({ selectedPrompt: x.name });
  }

  handleChangeLang = (event) => { this.setState({ language: event.target.value }) };

  render() {
    let pageComponent = null;

    if (this.state.showBatchPage) {
      pageComponent = <App />;
    } else {
      pageComponent = (
        <Container className="app-container2">
          <div className="card text-white bg-light mb-3 text-center">
            <span>
              <img
                className="imgbrder"
                src={ctlogo}
                alt="TJX"
                style={{
                  height: "105px",
                  width: "225px",
                }}
              />{" "}
              {/* <img
                src={Logo}
                alt="TJX"
                style={{ height: "10%", width: "10%", objectFit: "cover" }}
              /> */}
            </span>

            <h3 style={{ color: "black" }}>
              {" "}
              Cognizant® Call Performance Analyzer - powered by WorkNext AI
            </h3>
            <p> </p>
            <div className="menubar">
              <div className="menu-btn-bg">
                <form className="row row-cols-lg-auto g-3 align-items-center text-white">
                  <div className="col-2">
                    <select
                      className="form-select"
                      id="formSelectBatchLanguage"
                      style={{ width: "200px", marginLeft: 15 }}
                    >
                      <option value="en-IN">English (India)</option>
                      <option value={this.state.language} onChange={this.handleChangeLang}>
                        English (USA)
                      </option>
                      <option value="en-GB">English (UK)</option>
                      <option value="es-ES">Spanish (Spain)</option>
                      <option value="es-MX">Spanish (Mexico)</option>
                      <option value="fr-CA">French (Canada)</option>
                      <option value="fr-FR">French (France)</option>
                      <option value="it-IT">Italian (Italy)</option>
                      <option value="ja-JP">Japanese (Japan)</option>
                      <option value="da-DK">Danish (Denmark)</option>
                      <option value="wuu-CN">Chinese (Wu, Simplified)</option>
                      <option value="hi-IN">Hindi (India)</option>
                      <option value="gu-IN">Gujarati (India)</option>
                      <option value="te-IN">Telugu (India)</option>
                      <option value="de-DE">German (Germany)</option>
                      <option value="ar-EG">Arabic (Egypt)</option>
                      <option value="ar-IL">Arabic (Israel)</option>
                      <option value="ar-SA">Arabic (Saudi Arabia)</option>
                      <option value="ko-KR">Korean (Korea)</option>
                      <option value="nl-NL">Dutch (Netherlands)</option>
                      <option value="pt-BR">Portuguese (Brazil)</option>
                      <option value="pt-PT">Portuguese (Portugal)</option>
                      <option value="sv-SE">Swedish (Sweden)</option>
                      <option value="he-IL">Hebrew (Israel)</option>
                      <option value="th-TH">Thai (Thailand)</option>
                      <option value="ta-IN">Tamil (India)</option>
                      <option value="mr-IN">Marathi (India)</option>
                      <option value="pl-PL">Polish (Poland)</option>
                      <option value="nb-NO">Norwegian Bokmål (Norway)</option>
                    </select>
                  </div>
                  <div
                    className="col-8"
                    style={{
                      justifyContent: "center",
                      display: "flex",
                      marginRight: "50px",
                    }}
                  >
                    {/* <Button
                      style={{ marginRight: 15 }}
                      color="success"
                      onClick={() => this.sttFromMic()}
                    >
                      Start Listening
                    </Button> */}
                    <input
                      type="file"
                      name="audio"
                      accept="audio/*"
                      onChange={this.handleFileInputChange}
                      style={{ color: "black", marginTop: "3px" }}
                    />
                    <button
                      type="button"
                      className="button-85"
                      onClick={this.handleTranscribeButtonClick}
                    >
                      Transcribe
                    </button>
                  </div>
                  {/* <div style={{float: 'right', display:'flex'}}> */}

                  <ButtonGroup>
                    <Button onClick={this.handleToggle} color="secondary">
                      Live
                    </Button>
                    <Button
                      className={
                        this.state.showBatchPage === true ? "active" : "active"
                      }
                      color="danger"
                      style={{ border: 10 }}
                    >
                      Batch
                    </Button>
                  </ButtonGroup>

                  {/* </div> */}
                  {/* </div> */}
                </form>
              </div>
            </div>
            <form className="row row-cols-lg-auto g-3 align-items-center text-white">
              {/* <div class="col-2">
                <select
                  class="form-select"
                  id="formSelectBatchLanguage"
                  style={{ width: "200px", marginLeft: 15 }}
                >
                  <option value="en-IN">English (India)</option>
                  <option value="en-US" selected>
                    English (USA)
                  </option>
                  <option value="en-GB">English (UK)</option>
                  <option value="es-ES">Spanish (Spain)</option>
                  <option value="es-MX">Spanish (Mexico)</option>
                  <option value="fr-CA">French (Canada)</option>
                  <option value="fr-FR">French (France)</option>
                  <option value="it-IT">Italian (Italy)</option>
                  <option value="ja-JP">Japanese (Japan)</option>
                  <option value="da-DK">Danish (Denmark)</option>
                  <option value="wuu-CN">Chinese (Wu, Simplified)</option>
                  <option value="hi-IN">Hindi (India)</option>
                  <option value="gu-IN">Gujarati (India)</option>
                  <option value="te-IN">Telugu (India)</option>
                  <option value="de-DE">German (Germany)</option>
                  <option value="ar-EG">Arabic (Egypt)</option>
                  <option value="ar-IL">Arabic (Israel)</option>
                  <option value="ar-SA">Arabic (Saudi Arabia)</option>
                  <option value="ko-KR">Korean (Korea)</option>
                  <option value="nl-NL">Dutch (Netherlands)</option>
                  <option value="pt-BR">Portuguese (Brazil)</option>
                  <option value="pt-PT">Portuguese (Portugal)</option>
                  <option value="sv-SE">Swedish (Sweden)</option>
                  <option value="he-IL">Hebrew (Israel)</option>
                  <option value="th-TH">Thai (Thailand)</option>
                  <option value="ta-IN">Tamil (India)</option>
                  <option value="mr-IN">Marathi (India)</option>
                  <option value="pl-PL">Polish (Poland)</option>
                  <option value="nb-NO">Norwegian Bokmål (Norway)</option>
                </select>
              </div> */}

              <div
                className="col-8"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {/* <input
                  type="file"
                  name="audio"
                  onChange={this.handleFileInputChange}
                  style={{ color: "black" }}
                />
                <button
                  type="button"
                  class="button-85"
                  onClick={this.handleTranscribeButtonClick}
                >
                  Transcribe
                </button> */}
                {/* <button type='button' onClick={this.handleToggle} style={{float: 'right'}}>Live Page</button> */}
              </div>

              {/* <div style={{float: 'right', display:'flex'}}> */}
              {/* <ButtonGroup>
                <Button
                  onClick={this.handleToggle}
                  color="secondary"
                  style={{ border: 10 }}
                >
                  Live
                </Button>
                <Button
                  className={
                    this.state.showBatchPage === true ? "active" : "active"
                  }
                  color="danger"
                  style={{ border: 10 }}
                >
                  Batch
                </Button>
              </ButtonGroup> */}

              {/* </div> */}
            </form>
            <p> </p>

            <div
              style={{
                fontSize: 18,
                display: "flex",
                justifyContent: "center",
                color: "black",
              }}
            >
              {this.state.isLoading ? (
                <div>
                  <p>Please wait while the transcript gets generated!</p>
                  <h6>Loading...</h6>
                </div>
              ) : (
                <div> </div>
              )}
            </div>

            <div>
              <audio
                ref={this.audioRef}
                className="audio-player"
                onTimeUpdate={this.handleTimeUpdate}
                controls
              />
              {/* <p>Current Time: {this.state.currentTime}</p> */}
              {this.state.selectedFile && (
                <div>
                  {this.state.isPlaying ? (
                    <button
                      type="button"
                      onClick={this.pauseAudio}
                      style={{
                        marginLeft: 0,
                        marginBottom: 12,
                        marginTop: 10,
                        background: "#fffafa",
                        borderRadius: 6,
                        color: "black",
                        width: 60,
                      }}
                    >
                      Pause
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={this.playAudio}
                      style={{
                        marginLeft: 0,
                        marginBottom: 12,
                        marginTop: 10,
                        background: "#fffafa",
                        borderRadius: 6,
                        color: "black",
                        width: 60,
                      }}
                    >
                      Play
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              {/* <div
                style={{
                  color: "black",
                  fontSize: 18,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                }}
              >
                Transcription
              </div> */}
            </div>
          </div>

          <div className="row">
            {/* <div>
              <p>Transcription</p>
              <span style={{ color: "black" }}>ment Index: </span>
              <span style={{ color: "#006400" }}>
                &nbsp;&nbsp;&#x2022;&nbsp;Positive
              </span>
              <span style={{ color: "#ff8c00" }}>
                &nbsp;&nbsp;&#x2022;&nbsp;Neutral
              </span>
              <span style={{ color: "#ff0000" }}>
                &nbsp;&nbsp;&#x2022;&nbsp;Negative
              </span>
            </div> */}
            <div
              className="col-6 parentdiv-textara"
              style={{ width: "48%", marginLeft: "11px" }}
            >
              <div
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  marginLeft: "9px",
                  background: "#d3d3d3",
                  padding: "6px",
                  borderRadius: "10px",
                }}
              >
                <div>Transcript </div>
                <br></br>
                <div>
                  <span style={{ color: "black" }}>
                    &nbsp;Sentiment Index:{" "}
                  </span>
                  <span style={{ color: "#006400" }}>
                    &nbsp;&nbsp;&#x2022;&nbsp;Positive
                  </span>
                  <span style={{ color: "#ff8c00" }}>
                    &nbsp;&nbsp;&#x2022;&nbsp;Neutral
                  </span>
                  <span style={{ color: "#ff0000" }}>
                    &nbsp;&nbsp;&#x2022;&nbsp;Negative
                  </span>
                </div>
              </div>
              <div
                id="transcriptTextarea"
                style={{
                  marginLeft: 5,
                  height: 300,
                  width: "98%",
                  background: "white",
                  overflowY: "auto",
                }}
              >
                {this.state.modifiedConversation1.map((sentence, index) => {
                  let sentimentColor;
                  if (sentence.includes("{positive}")) {
                    sentimentColor = "#006400 "; //green
                  } else if (sentence.includes("{negative}")) {
                    sentimentColor = "#ff0000"; //red
                  } else {
                    sentimentColor = "#ff8c00"; //orange
                  }
                  const sentenceText = sentence.replace(
                    /{(positive|negative|neutral)}/g,
                    ""
                  );
                  const [tag, text] = sentenceText.split(":");

                  return (
                    <div
                      onClick={() => this.handleSentenceClick({ index })}
                      key={index}
                      style={{ height: "auto", color: "black" }}
                    >
                      <span
                        style={{ color: sentimentColor, fontWeight: "bold" }}
                      >
                        {tag}:
                      </span>
                      <span
                        style={{
                          background:
                            this.state.currentSentenceIndex === index
                              ? "yellow"
                              : "transparent",
                        }}
                        contentEditable={true}
                      >
                        {" "}
                        {text}
                      </span>
                      <div style={{ height: "12px" }}></div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              className="col-6 parentdiv-textara "
              style={{ width: "49%", marginLeft: "12px", height: "350" }}
            >
              {/* <code style={{"color":"black"}}>{this.state.displayNLPOutput}</code> */}
              {/* <div className="col-6 nlpoutput-display rounded" id="infotextarea" style={{ height: 80 , width: 557}}>                      
            <button type="button" class="btn btn-info btn-sm float-end" onClick={() => this.gptPersonInfo(this.state.displayText)}>Extract Names</button>
            <code style={{"color":"black"}}>{this.state.gptPrompt}</code>
                </div> */}
              <div
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  background: "#d3d3d3",
                  padding: "6px",
                  borderRadius: "10px",
                }}
              >
                <div> Call Insights Extraction</div>
              </div>
              <div
                style={{
                  color: "black",
                  fontSize: 16,
                  alignItems: "left",
                  padding: "6px",
                  borderRadius: "10px",
                }}
              >
                <div style={{ height: 60, width: "100%" }}>
                  <textarea
                    id="durationtextarea"
                    style={{ height: 58, width: "100%" }}
                  >
                    Duration of the audio is...
                  </textarea>
                </div>

                <div
                  className="col-6 nlpoutput-display rounded"
                  id="infotextarea"
                  style={{ height: 230, width: "100%", position: "relative" }}
                >
                  <Button
                    style={{ position: "absolute", right: 0, margin: 5 }}
                    color="primary"
                    onClick={() => this.gptKeyTopics(this.state.displayText)}
                  >
                    Extract Key Topics
                  </Button>
                  <code style={{ color: "black" }}>
                    {this.state.gptPrompt2}
                  </code>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              color: "black",
              fontSize: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            .
          </div>
          <div
            style={{
              color: "black",
              fontSize: 22,
              display: "flex",
              justifyContent: "center",
            }}
          >
            BYOP (Bring Your Own Prompt) to extract business insights
          </div>
          <div
            style={{
              color: "black",
              fontSize: 5,
              display: "flex",
              justifyContent: "center",
            }}
          >
            .
          </div>
          <div className="row text-dark">
            <div
              className="col-6 parentdiv-textara"
              style={{ position: "relative", width: "48%", marginLeft: "7px" }}
            >
              <div
                className="header-bg"
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  marginBottom: "8px",
                  background: "#d3d3d3",
                  padding: "6px",
                  borderRadius: "10px",
                }}
              >
                <Row>
                  <Col>
                    <Dropdown
                      id="promptName"
                      isOpen={this.state.dropdownOpen}
                      toggle={this.toggle}
                    >
                      <DropdownToggle caret>
                        {this.state.selectedPrompt
                          ? this.state.selectedPrompt
                          : "Select a Pre-defined Prompt"}
                      </DropdownToggle>
                      <DropdownMenu positionFixed={true}>
                        {this.state.prompts &&
                          this.state.prompts.map((x) => (
                            <DropdownItem
                              value={x.prompt}
                              onClick={() =>
                                this.handleAIPromptDropdownSelect(x)
                              }
                            >
                              {x.name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                  <Col>
                    <Button
                      style={{
                        position: "absolute",
                        right: 0,
                        marginRight: 15,
                      }}
                      color="primary"
                      onClick={() =>
                        this.gptCustomPromptCompetion(this.state.displayText)
                      }
                    >
                      Extract Insights
                    </Button>
                  </Col>
                </Row>
              </div>
              <textarea
                className="form-control"
                id="customPromptTextarea"
                rows="10"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  borderWidth: "2px",
                  borderColor: "white",
                  borderStyle: "groove",
                  overflowY: "auto",
                }}
              >
                Enter a prompt here
              </textarea>
            </div>
            <div
              className="col-6"
              style={{
                backgroundColor: "#efebf3",
                padding: "10px",
                borderRadius: "20px",
                width: "49%",
                marginLeft: "10px",
              }}
            >
              <div
                className="col-6 nlpoutput-display rounded"
                style={{ height: 300, width: "98%" }}
              >
                <div
                  style={{
                    color: "black",
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "left",
                    marginBottom: "44",
                    background: "#d3d3d3",
                    padding: "6px",
                    borderRadius: "10px",
                    marginBottom: "10px",
                  }}
                >
                  Prompt Response
                </div>
                <code style={{ color: "black", overflowY: "scroll" }}>
                  {this.state.gptCustomPrompt}
                </code>
              </div>
            </div>
            {/* <div
              className="col-6 nlpoutput-display rounded  "
              style={{ height: 300, width: "49%",  }}
            >
              <code style={{ color: "black", overflowY: "scroll" }}>
                {this.state.gptCustomPrompt}
              </code>
            </div> */}
          </div>
          <p> </p>
          {/* <div class="row text-dark">
                        <div class="col-6">
                            <label for="customPromptTextarea" class="form-label" style={{ "color": "black" }}>Enter your custom prompt:</label>
                            <button type="button" class="btn btn-info btn-sm float-end" onClick={() => this.gptCustomPromptCompetion2(this.state.displayText)}>Extract Insights</button>
                            <textarea class="form-control" id="customPromptTextarea2" rows="10" style={{ backgroundColor: "white", "color": "black", "borderWidth": "2px", 'borderColor': "white", 'borderStyle': 'groove', overflowY: 'scroll' }}>
                                Enter a prompt here
                            </textarea>
                        </div>
                        <div className="col-6 nlpoutput-display rounded " style={{ height: 300 }}>
                            <code style={{ "color": "black" }}>{this.state.gptCustomPrompt2}</code>
                        </div>
                    </div> */}
        </Container>
      );
    }
    return <div>{pageComponent}</div>;
  }
}
